
    import { Component, Vue } from 'vue-property-decorator';
    import { ApiRepository } from "@/api";
    import Layout from '@/components/layout/Layout.vue';
    import Filters from '@/components/table/Filters.vue';
    import Table from "@/components/table/Table.vue";

    @Component({
        components: {
            Filters,
            Layout,
            Table
        },
    })
    export default class CardNumbers extends Vue {
        private partner: any = {};
        private data: any = [];

        private keys = {
            cardNr: 'Číslo karty',
            occupied: 'Obsadená',
            createdAt: 'Naimportovaná',
            name: 'Meno držiteľa',
            surname: 'Priezvisko držiteľa',
            updatedAt: 'Pridelená'
        };

        private excludedSorters = ['name', 'surname'];

        private filters = '';

        // paging
        private pager = {
            count: 0,
            take: 0,
            page: 0,
            totalCount: 0
        };

        // sorting
        private key = '';
        private sort = '';

        public async mounted() {
            this.partner = await ApiRepository.getPartner(this.$route.params.partner);

            await this.sendRequest();
        }

        private async sendRequest(params: object = {}) {
            let response = await ApiRepository.getPartnerCardNumbers(this.$route.params.partner, params);

            this.data = response.data;
            this.pager = {
                count: response.count,
                take: response.take,
                page: response.page,
                totalCount: response.totalCount
            };
        }

        private async setFilter(filters: any) {
            let strFilter: any = [];

            if (filters) {
                Object.keys(filters).forEach((key: string) => {
                    strFilter.push(key + ':' + filters[key]);
                });
            }
            strFilter = strFilter.join(',');

            this.filters = strFilter;

            await this.sendRequest({
                sort: this.key || 'cardNr',
                order: this.sort ? 'ASC' : 'DESC',
                filters: strFilter
            });
        }

        private async changeOptions(data: any) {
            let response = await ApiRepository.getPartnerCardNumbers(this.$route.params.partner, {
                sort: data.key,
                order: data.sort ? 'ASC' : 'DESC',
                filters: this.filters,
            });

            this.data = response.data;

            this.pager.page = data.page || this.pager.page;
            this.key = data.key;
            this.sort = data.sort;

            await this.sendRequest({
                page: this.pager.page,
                sort: this.key,
                order: this.sort ? 'ASC' : 'DESC',
                filters: this.filters
            });
        }

        private async changePage(page: Number) {
            await this.changeOptions({
                key: this.key || 'id',
                page: page
            });
        }
    }
